import Schema, { required } from 'AppReact/schema';

const dropdownOption = {
  id: required(['string', 'integer']),
  label: required('string'),
}

export default {
  selectedIds: Schema('integer', 'array', { defaultValue: [] }),
  entries: Schema(dropdownOption, 'array', { defaultValue: [] }),
  label: Schema('string', 'primitive-nullable', { defaultValue: null }),
  icon: Schema({}, 'object', { defaultValue: null }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  searchVal: Schema('string', 'primitive', { defaultValue: '' }),
  pageNumber: Schema('integer', 'primitive', { defaultValue: 1 }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
};
